import { PillProps } from '@common/types';
import React from 'react';

export default (props: PillProps) => {
  let pillClasses =
    'tour__header-info tour__header-info--left text-uppercase d-table';

  if (props.class) {
    pillClasses = `${pillClasses} ${props.class}`;
  }

  if (!props.icon && !props.text) {
    return null;
  }

  return (
    <span className={pillClasses}>
      {props.icon ? <i className={props.icon}></i> : null}
      {props.text ? props.text : null}
    </span>
  );
};
